import { render, staticRenderFns } from "./Imagen.vue?vue&type=template&id=74aa8dd6&"
import script from "./Imagen.vue?vue&type=script&lang=js&"
export * from "./Imagen.vue?vue&type=script&lang=js&"
import style0 from "./Imagen.vue?vue&type=style&index=0&id=74aa8dd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports